import { patientActions, noteActions, userActions } from '_actions'
import { createReducer } from '@reduxjs/toolkit'

const initialState = {
};

export const reducer = createReducer(initialState, {
    [patientActions.loadSuccess]: (state, action) => {
        var admits = {};

        Object.values(action.payload.entities.admissions).forEach(x => {
            admits[x.id] = {
                id: x.id,
                ptno: x.ptno,
                visible: x.dischargeDate === null ? true : false,
                specialProgReqVisible: false,
                startEvalOptionsVisible: false,
                startNoteWarning: undefined,
                startNoteDisplayWarnings: undefined,
                newScribeVisible: false,
                aptid: undefined,
                adtdate: undefined,
                fotoPanelVisible: false,
                fotoPanelLoading: false,
                fotoRefreshing: false,
                rtmVisible: false,
                rtmSubmitting: false,
                noteStarting: false,
                therapists: null,
                startEvalOptionsStatus: null,
                thurno: null
            };
        });
        state = { ...state, ...admits };

        return state;
    },
    [userActions.loadSessionSuccess]: (state, action) => {
        var admits = {};

        if (action.payload.patientsContainer.entities.admissions) {
            Object.values(action.payload.patientsContainer.entities.admissions).forEach(x => {
                admits[x.id] = {
                    id: x.id,
                    ptno: x.ptno,
                    visible: x.dischargeDate === null ? true : false,
                    specialProgReqVisible: false,
                    startEvalOptionsVisible: false,
                    startEvalOptionsStatus: null,
                    startNoteWarning: undefined,
                    startNoteDisplayWarnings: undefined,
                    newScribeVisible: false,
                    aptid: undefined,
                    adtdate: undefined,
                    fotoPanelVisible: false,
                    fotoPanelLoading: false,
                    fotoRefreshing: false,
                    rtmVisible: false,
                    rtmSubmitting: false,
                    noteStarting: false,
                    therapists: null,
                    isScribe: false,
                    thurno: null
                };
            });
        }
        state = { ...state, ...admits };

        return state;
    },
    [patientActions.closeSuccess]: (state, action) => {
        return Object.values(state).forEach(x => {
            if (x.ptno === action.payload) {
                delete state[x.id];
            }
        })
    },
    [patientActions.toggleAdmissionVisibility]: (state, action) => {
        state[action.payload.epno].visible = !state[action.payload.epno].visible
    },
    [patientActions.toggleFotoPanelVisibility]: (state, action) => {
        state[action.payload.epno].fotoPanelVisible = !state[action.payload.epno].fotoPanelVisible
    },
    [patientActions.changeFotoClaimStatusRequest]: (state, action) => {
        state[action.payload.epno].fotoPanelLoading = true;
    },
    [patientActions.changeFotoClaimStatusSuccess]: (state, action) => {
        state[action.payload.epno].fotoPanelLoading = false;
    },
    [patientActions.changeFotoClaimStatusFailure]: (state, action) => {
        state[action.payload.epno].fotoPanelLoading = false;
    },
    [patientActions.refreshFotoEpisodesRequest]: (state, action) => {
        state[action.payload.epno].fotoRefreshing = true;
    },
    [patientActions.refreshFotoEpisodesSuccess]: (state, action) => {
        state[action.payload.epno].fotoRefreshing = false;
    },
    [patientActions.refreshFotoEpisodesFailure]: (state, action) => {
        state[action.payload.epno].fotoRefreshing = false;
    },
    [patientActions.refreshFotoEpisodesForPatientRequest]: (state, action) => {
        Object.values(state).forEach(x => {
            if (x.ptno === action.payload.ptno) {
                state[x.id].fotoRefreshing = true;
            }
        })
    },
    [patientActions.refreshFotoEpisodesForPatientSuccess]: (state, action) => {
        Object.values(state).forEach(x => {
            if (x.ptno === action.payload.ptno) {
                state[x.id].fotoRefreshing = false;
            }
        })
    },
    [patientActions.refreshFotoEpisodesForPatientFailure]: (state, action) => {
        Object.values(state).forEach(x => {
            if (x.ptno === action.payload.ptno) {
                state[x.id].fotoRefreshing = false;
            }
        })
    },
    [patientActions.showSpecialProgReq]: (state, action) => {
        state[action.payload.epno].specialProgReqVisible = true
    },
    [patientActions.hideSpecialProgReq]: (state, action) => {
        state[action.payload.epno].specialProgReqVisible = false
    },
    [noteActions.startNoteWarning]: (state, action) => {
        state[action.payload.epno].startNoteWarning = action.payload.status;
        state[action.payload.epno].noteStarting = false;
    },
    [noteActions.startNoteDisplayWarnings]: (state, action) => {
        state[action.payload.epno].startNoteDisplayWarnings = action.payload.message;
        state[action.payload.epno].noteStarting = false;
    },
    [noteActions.startNoteDisplayWarningsClear]: (state, action) => {
        state[action.payload.epno].startNoteDisplayWarnings = undefined;
        state[action.payload.epno].noteStarting = false;
    },
    [noteActions.startNoteWarningClear]: (state, action) => {
        state[action.payload.epno].startNoteDisplayWarnings = undefined
    },
    [noteActions.startNoteEvalOptions]: (state, action) => {
        var prepopCount = action.payload.response.entities.prepopulateEvals ? Object.keys(action.payload.response.entities.prepopulateEvals).length : 0;
        var transferCount = action.payload.response.entities.transferEvals ? Object.keys(action.payload.response.entities.transferEvals).length : 0;
        state[action.payload.response.result.epno].startEvalOptionsVisible = true;
        state[action.payload.response.result.epno].startEvalOptionsStatus = action.payload.response.result.status ? action.payload.response.result.status : -1;
        state[action.payload.response.result.epno].thurno = action.payload.thurno ? action.payload.thurno : false;
        state[action.payload.response.result.epno].startNoteWarning = undefined;
        state[action.payload.response.result.epno].startNoteDisplayWarnings = undefined;
        state[action.payload.response.result.epno].aptid = action.payload.response.result.aptid;
        state[action.payload.response.result.epno].noteStarting = false;
        if (action.payload.response.result.adtdate) {
            state[action.payload.response.result.epno].adtdate = new Date(action.payload.response.result.adtdate);
        }
    },
    [noteActions.startNoteEvalOptionsPeds]: (state, action) => {
        state[action.payload.epno].startEvalPedsOptionsVisible = true;
        state[action.payload.epno].isScribe = action.payload.isScribe;
        state[action.payload.epno].isScribeTHURNO = action.payload.thurno;
    },
    // [patientActions.setUsePedsSuccess]: (state, action) => {
    //     state[action.payload.epno].startEvalPedsOptionsVisible = false;
    // },
    [noteActions.startNoteEvalOptionsClear]: (state, action) => {
        state[action.payload.epno].startEvalOptionsVisible = false;
        state[action.payload.epno].aptid = undefined;
        state[action.payload.epno].adtdate = undefined;
        state[action.payload.epno].noteStarting = false;

    },


    [noteActions.startBlankEvalRequest]: (state, action) => {
        state[action.payload.epno].noteStarting = true;
    },
    [noteActions.startBlankEvalSuccess]: (state, action) => {
        state[action.payload.epno].startEvalOptionsVisible = false;
        state[action.payload.epno].startNoteWarning = undefined;
        state[action.payload.epno].noteStarting = false;
    },
    [noteActions.startBlankEvalFailure]: (state, action) => {
        state[action.payload.epno].noteStarting = false;
    },


    [noteActions.transferEvalRequest]: (state, action) => {
        state[action.payload.epno].noteStarting = true;
    },
    [noteActions.transferEvalSuccess]: (state, action) => {
        state[action.payload.epno].startEvalOptionsVisible = false;
        state[action.payload.epno].startNoteWarning = undefined
        state[action.payload.epno].noteStarting = false;

    },
    [noteActions.transferEvalFailure]: (state, action) => {
        state[action.payload.epno].noteStarting = false;
    },


    [noteActions.prepopulateEvalRequest]: (state, action) => {
        state[action.payload.epno].noteStarting = true;
    },
    [noteActions.prepopulateEvalSuccess]: (state, action) => {
        state[action.payload.epno].startEvalOptionsVisible = false;
        state[action.payload.epno].startNoteWarning = undefined
        state[action.payload.epno].noteStarting = false;
    },
    [noteActions.prepopulateEvalFailure]: (state, action) => {
        state[action.payload.epno].noteStarting = false;
    },


    [noteActions.startNoteRequest]: (state, action) => {
        state[action.payload.epno].noteStarting = true;
    },
    [noteActions.startNoteSuccess]: (state, action) => {
        state[action.payload.epno].noteStarting = false;
    },
    [noteActions.startNoteFailure]: (state, action) => {
        state[action.payload.epno].noteStarting = false;
    },
    [noteActions.startNoteFailurePerm]: (state, action) => {
        state[action.payload.epno].noteStarting = false;
    },
    [noteActions.startNoteFailureDisc]: (state, action) => {
        state[action.payload.epno].noteStarting = false;
    },
    [patientActions.toggleRtmVisibility]: (state, action) => {
        state[action.payload.epno].rtmVisible = !state[action.payload.epno].rtmVisible
    },
    [patientActions.createRtmNoteRequest]: (state, action) => {
        state[action.payload.epno].rtmSubmitting = true;
    },
    [patientActions.createRtmNoteSuccess]: (state, action) => {
        state[action.payload.epno].rtmVisible = false;
        state[action.payload.epno].rtmSubmitting = false;
    },
    [patientActions.createRtmNoteFailure]: (state, action) => {
        state[action.payload.epno].rtmSubmitting = false;
    },
    [patientActions.showScribeOptionsSuccess]: (state, action) => {
        state[action.payload.epno].newScribeVisible = true;
    },
    [patientActions.hideScribeOptions]: (state, action) => {
        state[action.payload.epno].newScribeVisible = false;
    },

})


